export const ApiEndpoints = {
    LOGIN: '/users/login-otp',
    REGISTER: '/users/signup',
    VERIFY: '/verify/otp',
    RESETPASSWORD: '/users/reset-password',
    FORGOTPASSWORD: '/users/reset-password',
    LOGOUT: '/users/logout',
    UPDATEPROFILE: '/users/update_profile',
    REFRESHTOKEN: '/users/token',
    GET_PRODUCTS: '/requests/zoho/get-products',
    GET_CATEGORIES: '/requests/zoho/get-formated-cat',
    GET_CATEGORY_DETAILS: '/zoho/categories/editpage',
    GET_PRODUCT_DETAIL: '/requests/zoho/get-product-detail',
    GROUPED_PRODUCTS: '/requests/zoho/grouped-product',
    GROUPED_PRODUCTS_DETAIL: '/requests/zoho/get-grouped-detail',
    CREATE_CART: '/requests/fazsion/create-cart',
    ADD_TO_CART: '/cart/add-product',
    CHECKOUT_CART: '/cart/checkout',
    UPDATE_CART: '/cart/update',
    VIEW_CART_DETAILS: '/requests/fazsion/get-cart-details',
    VIEW_CART: '/cart/list',
    GET_BANKS: '/requests/embedlyPayout/embedly-payout',
    REMOVE_FROM_CART: '/cart/remove-product',
    ADD_TO_WISHLIST: '/wish/add-product',
    REMOVE_FROM_WISHLIST: '/wish/remove-product',
    GET_WISHLIST: '/wish/list',
    CREATE_STORE: '/stores/create',
    GET_ORDERED_PRODUCTS: '/stores/get-available-product',
    ADD_TO_STORE: '/stores/add-product',
    GET_STORE: '/stores',
    REMOVE_FROM_STORE: '/stores/remove-product',
    GET_SHIPPING_DETAILS: '/requests/fazsion/get-shipping-methods',
    GET_CART_DETAILS: '/requests/fazsion/get-cart-details',
    ADD_SHIPPING_DETAILS: '/requests/fazsion/add-shipping-details',
    ADD_BILLING_ADDRESS: '/requests/fazsion/add-billing-address',
    PLACE_ORDER: '/requests/fazsion/place-order',
    GET_PRODUCT_STOCK: 'requests/fazsion/get-stock-items',
    GET_WALLET: '/wallet',
    WALLET_PAYOUT: '/wallet/payout',
    WITHDRAWAL_REQUEST: '/requests/embedlyPayout/embedly-bank-transfer',
    GET_ORDERS: '/orders',
    GET_BRANDS: '/requests/zoho/get-formated-brand',
    GET_BRAND:
        '/requests/fazsion/get-products-by-brand?pageSize=20&currentPage=1&attribute=mgs_brand&',
    GET_CUSTOMERS: '/requests/zoho/get-customer',
    GET_CUSTOMER_DETAILS: '/requests/zoho/get-customer-details',
    CREATE_CUSTOMER: '/requests/zoho/customer',
    UPDATE_CUSTOMER: '/requests/zoho/update-customer',
    GET_CURRENCIES: '/requests/startButton/exchange',
};
